import { Injectable } from '@angular/core';
import { InAppPurchase2, IAPProduct, IRefeshResult } from '@ionic-native/in-app-purchase-2/ngx';
import { ModalController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { RequestsService } from './requests.service';
import { ToasterComponent } from './toaster/toaster.component';

const PRODUCT_NAME = 'artist_vinyl_and_media';
const FREE_SUBSCRIBE = 'free_subscription_to_artist';

@Injectable({
    providedIn: 'root'
})
export class AppPurchase {

    artistId: string;
    price;
    props;

    constructor(private store: InAppPurchase2, private request: RequestsService, private navCtrl: NavController,
        private translate: TranslateService, private toast: ToasterComponent, private loader: LoaderComponent,
        private toaster: ToasterComponent, private modalController: ModalController) {
    }

    public getProducts() {
        return this.store.products;
    }

    public registerProduct() {
        this.store.register([
            {
                id: PRODUCT_NAME,
                type: this.store.NON_RENEWING_SUBSCRIPTION,
            },
            {
                id: FREE_SUBSCRIBE,
                type: this.store.NON_RENEWING_SUBSCRIPTION,
            }
        ]);

        this.store.when(PRODUCT_NAME)
            .approved((p: IAPProduct) => p.verify())
            .verified((p: IAPProduct) => this.subscribeToArtist(p));

        this.store.when(FREE_SUBSCRIBE)
            .approved((p: IAPProduct) => {
                console.log('on va verifiééééé');
                p.verify();
            })
            .verified((p: IAPProduct) => {
                console.log('on est vérifiéééé');
                this.subscribeFreeToArtist(p);
            });

        this.store.ready(() => {
            console.log('store products !!!');
            console.log(this.store.products);
            this.price = this.store.products[0].price;
        });
    }

    public storeRefresh() {
        this.store.refresh();
    }

    async subscribeFreeToArtist(p: IAPProduct) {
        const message = await this.translate.get('charging').toPromise();
        await this.loader.presentLoading(message + '...');

        await this.request.activateQrcode(this.props.qrcode)
            .then(() => {
                p.finish();
                this.toaster.successToast('scan_successfull');
                this.navCtrl.navigateRoot('/vinyl/' + this.props.id);
            })
            .catch(() => {
                this.toaster.errorToast('vinyl_already_used');
            })
            .finally(async () => {
                await this.loader.dismiss();
                await this.modalController.dismiss();
            });
    }

    async subscribeToArtist(p: IAPProduct) {
        const message = await this.translate.get('charging').toPromise();
        await this.loader.presentLoading(message + '...');
        this.request.subscribeToArtist({
            artistPublicId: this.artistId,
            subscriptionDuration: 30
        })
            .then(() => {
                p.finish();
                this.loader.dismiss();
                this.toast.infoToast('purchase_successfull');
                this.navCtrl.navigateRoot('tabs/artists');
            })
            .catch(() => {
                this.loader.dismiss();
                this.toast.errorToast('purchase_error');
            });
    }

    public refreshInfos(): IRefeshResult {
        return this.store.refresh();
    }

    public orderProduct(id, props = null) {
        if (props) {
            this.props = props;
        };

        this.store.order(id)
            .error(() => {
                this.toast.errorToast('error_internet');
            });
    }

    public convertNameToStoreId(name) {
        const compactName = name.trim().toLowerCase();
        return compactName.replaceAll(' ', '_').replaceAll('&', 'and');
    }
}
